import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "material-ui/styles";

import storage from "utils/storage";

const styles = {
  button: {
    margin: 10
  },
  develop: {
    textAlign: "center"
  },
  noMatch: {
    textAlign: "center"
  }
};

const NoMatch = props => {
  const { classes } = props;
  const devModeFlg = storage.getDevModeFlg();

  return (
    <div>
      {process.env.NODE_ENV === "development" && (
        <button
          onClick={() => {
            storage.setDevModeFlg(!devModeFlg);
            window.location.reload();
          }}
          className={classes.button}
        >
          {devModeFlg ? "404ページへ" : "開発者向け機能へ"}
        </button>
      )}

      {process.env.NODE_ENV === "development" &&
        devModeFlg && (
          <div className={classes.develop}>
            <div>開発者向け機能</div>
            <button
              className={classes.button}
              onClick={() => props.historyPush("/admin/login")}
            >
              管理者ログインへ
            </button>
            <button
              className={classes.button}
              onClick={() => props.historyPush("/customer_admin")}
            >
              顧客担当者ログインへ
            </button>
            <button
              className={classes.button}
              onClick={() =>
                props.historyPush("/answer/login/survey/R2ka2YU6rmaT1")
              }
            >
              回答者ログインへ
            </button>
          </div>
        )}

      {(process.env.NODE_ENV === "production" || !devModeFlg) && (
        <div className={classes.noMatch}>
          <div>404 NOT FOUND</div>
          <div>お探しのページは見つかりませんでした。</div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => {
    ownProps.history.push(path);
    window.location.reload();
  }
});

export default withRouter(
  connect(state => state, mapDispatchToProps)(withStyles(styles)(NoMatch))
);



// WEBPACK FOOTER //
// ./src/containers/NoMatchContainer.js